"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-param-reassign */
const node_fetch_1 = require("node-fetch");
const proxy_from_env_1 = require("proxy-from-env");
const shouldProxy = require('should-proxy');
const HttpsProxyAgent = require('https-proxy-agent');
function createProxyAgent(input, init) {
    // only add proxy server-side
    if (typeof window === 'undefined') {
        const url = typeof input === 'string' ? input : input.url;
        const proxy = proxy_from_env_1.getProxyForUrl(url);
        const should = shouldProxy(url, {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            no_proxy: process.env.NO_PROXY,
        });
        if (should && proxy) {
            init = init || {};
            init.agent = new HttpsProxyAgent(proxy);
        }
    }
    return init;
}
exports.createProxyAgent = createProxyAgent;
function proxyFetch(input, init) {
    return node_fetch_1.default(input, createProxyAgent(input, init));
}
exports.proxyFetch = proxyFetch;
//# sourceMappingURL=http-proxy-fetch.js.map